<template>
	<v-snackbar v-if="filteredContent.length" class="pa-0 ma-0" :color="colors[count]" v-model="notice" bottom right timeout="-1">
	<v-card dark flat :color="colors[count]" class="ma-0 assessment-notice"  width="400px">
		<v-card-title>			
			<span style="word-break: break-word">{{title}}</span>
			<v-btn icon @click="notice = 0" fab absolute right><v-icon>mdi-close</v-icon></v-btn>
		</v-card-title>
		<v-card-text class="pa-1">
			<div v-html="text"></div>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn text @click="nextTip" v-if="filteredContent.length > (count+1) " >Next Tip</v-btn>
		</v-card-actions>
	</v-card>
</v-snackbar>
</template>

<style lang="less">
	.assessment-notice{
		z-index: 50;
		font-size: 0.9em;
	}
</style>

<script type="text/javascript">
	// import Vuex from "vuex";
	// import - from "@/components/"
	export default {
		name: "AssessmentNotice", 
		data: () => {
			return {
				notice: 1,
				colors: ["primary2", "teal", "green", "yellow", "purple", "pink", "orange", "teal"],
				hidden: false,				
				count: 0, 
				content: [
					{
						limit: ["Analyse"],
						text: "<p>Nutzen Sie die erhobenen Daten zu jedem Zeitpunkt zur Darstellung und Ermittlung relevanter Digitalisierungsmehrwerte in Ihrer Einrichtung, vergleichen Sie feingranular Umsetzungsvorhaben und gestalten Sie datengesteuert Ihre spezifischen Versorgungsprozesse. </p><p>Ein Datenexport ist zu jedem Zeitpunkt möglich.</p>",

						title: "Ihre Erhebung, Ihre Daten, Ihre Auswertung"
					},
					{
						limit: ["Teams"],
						text: "<p>Mit unseren digitalen Kollaborationswerkzeugen  binden Sie alle relevanten Akteure zu jedem Zeitpunkt aktiv und effizient in Ihren Erhebungsprozess ein - delegieren Sie die Erhebung, komplett oder in Teilen, tauschen Sie sich live (und in Farbe) per Webkonferenz aus, realisieren Sie Miniumfragen und verwalten Sie alle Beteiligten an einem zentralen Ort. </p>",
						title: "Ihr Team hat alle Antworten"
					},
					{
						limit: ["Assessment"],
						text: "Mit dem Befragungsmodul ermitteln Sie gemeinsam mit relevanten Entscheider- und Anwendergruppen innerhalb von maximal 120 Minuten präzise die digitale Reife Ihres Krankenhauses und identifiziert zukünftige Handlungsfelder. Erfasst werden dafür multidimensionalen Datenpunkte zu <a class='white--text' href='/themes'>Struktur, Prozess und Ergebnisse.</a>",
						title: "Ihre Reifegradermittlung - zeitsparend, präzise, KHZG-konform"
					},
					{
						limit: ["Results"],
						text: "Das Dashboard präsentiert Ihnen den aktuellen Digitalisierungsgrad Ihres Krankenhauses in übersichtlicher und leicht verständlicher Form. Die im Erhebungsmodul erfassten Daten werden visualisiert und in einen eindeutigen Referenzscore überführt, der auf den Erhebungskategorien  <a class='white--text' href='/themes'>Struktur, Prozess und Ergebnisse</a> basiert.",
						title: "Ihr digitaler Reifegrad auf einen Blick"
					},
					// {
					// 	limit: ["Assessment"],
					// 	text:"Über das <i style='font-size: 16px' aria-hidden='true' class='v-icon notranslate mdi mdi-share-variant'></i> Symbol rechts oben haben Sie die Möglichkeit, Mitglieder Ihres Teams schnell und bequem zur Beantwortung von Erhebungsteilen hinzuzuziehen. Je nach Bedarf stehen Ihnen Funktionen zum Einladen einzelner oder mehrerer Mitarbeiter zur Verfügung!",
					// 	title: "Lassen sie Andere an ihrer Erhebung mitwirken"  
					// },
					// {
					// 	limit: ["Assessment"],
					// 	text: "Über die Teams-Verwaltung können Sie Mitarbeiter für die drei Kernbereiche IT, Klinikwesen und Verwaltung einrichten und somit per Mausklick unsere Voreinstellungen zum delegieren diverser Erhebungsteile nutzen.",
					// 	title: "Blitzschnell delegieren mit unsereren Voreinstellungen"
					// }
				]
			}
		},
		// components: {

		// },
		computed: {
	
			filteredContent(){
				var page = this.$route.name;
				return this.content.filter( c => {
					return !c.limit || c.limit.indexOf( page ) > -1
				})

			},
			text(){
				return this.filteredContent[this.count] ? this.filteredContent[this.count].text : ""
			},
			title(){
				return this.filteredContent[this.count] ? this.filteredContent[this.count].title : ""
			},
			page(){
				return this.$route.name
			}
			// ...Vuex.mapState({})
		},
		methods: {
			nextTip(){
				if( (this.count+1) < this.filteredContent.length ){
					this.count++;
				}
				else{
					this.notice = false;
				}
			}
		}, 
		watch: {
			page(){
				this.notice = true;
			}
		}
		// created(){
			
		// }

	}
</script>"